import React from 'react';
import { HtmlString } from '../../shared/types/HtmlString';
import { ComponentMessage } from '../../shared/enums/ComponentMessage';
import { Link } from 'react-router-dom';

interface Props {
  value: HtmlString;
}

const AccountIdUrlCell: React.FC<Props> = props => {
  return (
    <div>
      <Link to={`/google-analytics/accountId/accountId=${props.value}`}>
        {props.value ? props.value : ComponentMessage.NoDataShort}
      </Link>
    </div>
  );
};

export default AccountIdUrlCell;
